export default [
  {
    path: '/service-ip',
    name: 'ServiceIp',
    component: () => import('@/layout'),
    redirect: '/service-ip/service-ip-list',
    meta: {
      title: 'IP管理',
    },
    children: [
      {
        path: 'service-ip-list',
        name: 'ServiceIpList',
        component: () => import('@/views/web/service-ip/service-ip-list/list'),
        meta: {
          title: 'Ip管理',
          noCache: false,
          auth: true,
          trackCode: 'menu-25',
          trackName: 'Ip管理 - Ip管理',
          activeMenu: '/service-ip/service-ip-list',
        },
      },
    ],
  },
];

